import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { calculatorSchema } from './calculatorSchema';
import { z } from 'zod';
import { INTEREST_RATE, LOAN_TENURE, RENTAL_YIELD } from '@/constants/others/rental-yield';

export const initialState = {
  formField: {
    rentalYieldType: RENTAL_YIELD.GROSS,
    propertyValue: '',
    monthlyRentalPrice: '',
    annualShaving: '',
    propertyTax: '',
    monthlyMaintenanceFee: '',
    agentCommissionFee: '',
    others: '',
    bankLoanInterestYearly: '',
    loanAmount: '',
    loanTenure: LOAN_TENURE.DEFAULT.toString(),
    interestRate: INTEREST_RATE.toString(),
    loanStartYear: '',
    isCalculated: [] as any[],
    showSummary: false,
  },
  loading: true,
};

export const rentalYieldSlice = createSlice({
  name: 'rentalYield',
  initialState,
  reducers: {
    updateFormField: (state, action: PayloadAction<z.infer<typeof calculatorSchema>>) => {
      state.formField = action.payload;
    },
  },
  extraReducers: () => {},
});

export const { updateFormField } = rentalYieldSlice.actions;

export default rentalYieldSlice.reducer;
